import React, { useState, useEffect, useRef } from "react";
import { v4 as uuidv4} from "uuid"

import "./style.scss"

const ScaleText = ({ content }) => {
    const [scaleText, setScaleText] = useState(100);
    const [bulSetting, setBulSetting] = useState(false)
    const [idClock, setIdClock] = useState('');
    const clock = useRef(null);
    const clock2 = useRef(null);
    const clock3 = useRef(null);
    const clock4 = useRef(null);
    const countContent = useRef(0);
    const container = useRef(null);
    const scaleMemory = useRef(null);

    useEffect(() => {
        let scaleSave2 = localStorage.getItem("scaleSave2")
        if(scaleSave2){
            setScaleText(Number(scaleSave2))
        }
        window.addEventListener('storage', function(event) {
            if (event.key === 'scaleSave2') {
                if(!bulSetting){
                    setScaleText(Number(event.newValue))
                }
            }
        });
    },[])

    useEffect(() => {
        setIdClock(uuidv4())
      }, []);

    useEffect(() => {
        setBulSetting(true)
        if(clock.current){clearTimeout(clock.current)}
        clock.current = setTimeout(() => {
            localStorage.setItem("scaleSave2",scaleText)
            window.dispatchEvent(new StorageEvent('storage', {
                key: "scaleSave2",
                newValue: scaleText,
                oldValue: localStorage.getItem("scaleSave2")
            }));
            if(clock2.current){clearTimeout(clock2.current)}
            clock2.current = setTimeout(() => {
                setBulSetting(false)
            }, 200);
        }, 1000);
    },[scaleText])

    const setAllChanges = (click=false) => {
        if(clock4.current){clearTimeout(clock4.current)};
        clock4.current = setTimeout(() => {
            if(container.current && idClock){
                let containerAll = document.getElementById(`container-scale-all-${idClock}`);
                if(containerAll){
                    let containerAllS = containerAll.querySelectorAll("*");
                    if(countContent.current !== containerAllS.length || !click || scaleMemory.current !== scaleText){
                        for(let i = 0; i < containerAllS.length; i++){
                            const setAllBasicStyles = (bul=false) => {
                                const computedStyle = getComputedStyle(containerAllS[i]);
                                let fontSize = parseFloat(computedStyle.fontSize);
                                let lineHeight = parseFloat(computedStyle.fontSize);
                                let marginBottom = parseFloat(computedStyle.marginBottom);
                                let marginTop = parseFloat(computedStyle.marginTop);
                                if(!containerAllS[i].dataset.fontSize){containerAllS[i].dataset.fontSize = fontSize }else{
                                    fontSize = containerAllS[i].dataset.fontSize;
                                }
                                if(!containerAllS[i].dataset.lineHeight){containerAllS[i].dataset.lineHeight = lineHeight }else{
                                    lineHeight = containerAllS[i].dataset.lineHeight;
                                }
                                if(!containerAllS[i].dataset.marginBottom){
                                    containerAllS[i].dataset.marginBottom = (marginBottom === 0 || marginBottom === '0')
                                        ? 5 : marginBottom;
                                }else{
                                    marginBottom = containerAllS[i].dataset.marginBottom;
                                }
                                if(!containerAllS[i].dataset.marginTop){
                                    containerAllS[i].dataset.marginTop = (marginTop === 0 || marginTop === '0')
                                        ? 5 : marginTop;
                                }else{
                                    marginTop = containerAllS[i].dataset.marginTop;
                                }
                                if(Number(fontSize) !== 0){
                                    containerAllS[i].style.setProperty("font-size",`${Number(fontSize) * (scaleText / 100)}px`,'important');
                                    containerAllS[i].style.setProperty("line-height",`${Number(lineHeight) * (scaleText / 75)}px`,'important');
                                    containerAllS[i].style.setProperty("margin-bottom",`${Number(marginBottom) * (scaleText / 85)}px`,'important');
                                    containerAllS[i].style.setProperty("margin-top",`${Number(marginTop) * (scaleText / 85)}px`,'important');
                                }
                                // if(bul){
                                //     if (!containerAllS[i].querySelector('p, h2, h3, h4, label, div','li','ul','ol')) {
                                //         containerAllS[i].querySelectorAll('*').forEach(child => {
                                //             child.style.setProperty("font-size", "inherit", "important");
                                //             child.style.setProperty("line-height", "inherit", "important");
                                //             child.style.setProperty("margin-bottom", "inherit", "important");
                                //             child.style.setProperty("margin-top", "inherit", "important");
                                //         });
                                //     }
                                // }
                            }
                            if(['P','H2','H3','H4','LABEL','DIV'].includes(containerAllS[i].tagName)){
                                if(containerAllS[i].tagName === 'DIV'){
                                    if(containerAllS[i].classList.contains('ant-collapse') && containerAllS[i].classList.contains('ant-collapse-icon-position-start')){
                                        containerAllS[i].style.setProperty("margin-bottom",`${7.5 * (scaleText / 100)}px`,'important');
                                        containerAllS[i].style.setProperty("margin-top",`${7.5 * (scaleText / 100)}px`,'important');
                                    }
                                    if(!containerAllS[i].children[0] && containerAllS[i].textContent){
                                        setAllBasicStyles();
                                    }else{
                                        setAllBasicStyles(true);

                                    }
                                }else{
                                    setAllBasicStyles()
                                }
                            }
                            if(['LI'].includes(containerAllS[i].tagName)){
                                let element = ((containerAllS[i] || {}).children[0] || {}).tagName === 'P' ? (containerAllS[i] || {}).children[0] : containerAllS[i];
                                const computedStyle = getComputedStyle(element);
                                let fontSize = parseFloat(computedStyle.fontSize);
                                if(!element.dataset.fontSize){element.dataset.fontSize = fontSize }else{
                                    fontSize = element.dataset.fontSize;
                                }
                                if(Number(fontSize) !== 0){
                                    containerAllS[i].style.setProperty("font-size",`${Number(fontSize) * (scaleText / 100)}px`,'important');
                                }
                            }
                            if(['UL','OL'].includes(containerAllS[i].tagName)){
                                const computedStyle = getComputedStyle(containerAllS[i]);
                                let paddingLeft = parseFloat(computedStyle.paddingLeft);
                                if(!containerAllS[i].dataset.paddingLeft){containerAllS[i].dataset.paddingLeft = paddingLeft }else{
                                    paddingLeft = containerAllS[i].dataset.paddingLeft;
                                }
                                if(Number(paddingLeft) !== 0){
                                    containerAllS[i].style.setProperty("padding-left",`${Number(paddingLeft) * (scaleText / 100)}px`,'important');
                                }
                            }
                        } 
                    };
                    countContent.current = containerAllS.length;
                    scaleMemory.current = scaleText;
                }
            }
        }, 50);
    }

    useEffect(() => {
        setAllChanges();
    },[container, scaleText, content, idClock])

    const onClickScaleContainer = (e) => {
        if(clock3.current){clearTimeout(clock3.current);}
        if(e?.target?.className !== 'buttons-scale' && e?.target?.className !== 'container-buttons-scale'){
            clock3.current = setTimeout(() => {
                setAllChanges(true);
            }, 100); 
        }
        
    }

    return (
        <div className="container-scale-text" ref={container} onClick={(e) => onClickScaleContainer(e)}>
            <div className="container-buttons-scale">
                <div className="buttons-scale" onClick={() => setScaleText(scaleText - 10)}>-</div>
                <div style={{display:'inline'}}>{scaleText} %</div>
                <div className="buttons-scale" onClick={() => setScaleText(scaleText + 10)}>+</div>
            </div>
            <div className="container-scale-all" id={`container-scale-all-${idClock}`} translate="yes" >
                {content}
            </div>
        </div>
    );
};
export default ScaleText;
